import CTASection from "@/components/CTASection";

export default function Resources() {
  return (
    <div data-testid="resources-page">
      <section className="pt-16 pb-24 lg:pt-24 lg:pb-32">
        <div className="ob-container text-center">
          <div className="ob-eyebrow mb-6">Resources</div>
          <h1 className="ob-h1 max-w-4xl mx-auto">Coming soon.</h1>
          <p className="ob-lead mt-8 max-w-2xl mx-auto">
            We're putting together a set of free tools, guides and short reads to help business owners
            make smarter marketing decisions. Check back with us soon.
          </p>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
